import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "useReducer + useContext for easy global state without libraries",
  "description": "",
  "published": "2019-08-12T00:00:00.000Z",
  "redirect_from": ["/blog/usereducer-usecontext-for-easy-global-state-without-libraries/swizec/9182"],
  "categories": "Front End, Technical",
  "hero": "./img/techletter.app-screenshot-1565626955164.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Since `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth"
      }}>{`useAuth`}</a>{` is taking off, I wanted to talk about the global state management technique that makes it work. You might find it useful too, or think it's obvious, I was pretty excited when it clicked :)`}</p>
    <p>{`And when I say useAuth is taking off ...`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1160070774448726016"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "124.66367713004485%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'499\\'%20viewBox=\\'0%200%20400%20499\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M30%2022c-6%205-7%2011-4%2018%204%209%2017%2012%2023%205%201-2%201-2-1-2-4%200-5-3-2-5%201-1%203-2%204-1l1-1%201-2c2%202%202-1%201-5-3-9-16-13-23-7m8%2038c0%203-3%204-5%201-1-1-1-1-1%201%201%204%200%206-3%204-2-1-2-1-2%202%200%204%201%206%202%203h3c3%200%203%200%203-2%200-4%203-3%204%201%201%203%201%203%202%202h2l1%201c2-2%201-5-1-5s-3%200-3-4-2-8-2-4m23%201c-1%202-2%202-3%201-2-2-3-1-2%201%200%203-2%205-5%203-1-1-1-1-1%202%200%204%201%206%203%204l3-2%203-1c0-3%201-3%203%201l2%203%201-1h3c1-3%201-4-1-3-3%200-3%200-3-4%200-6-1-7-3-4m247%2021c0%203-3%204-5%201-1-1-1-1-1%202s-3%205-4%203-2%202-1%205c1%202%201%202%202%201%200-2%201-2%203-2s3%200%203-2c1-2%202-2%204%202%201%203%201%203%203%202h1l1%201c2-2%201-5-1-5s-3%200-3-4-2-8-2-4m23%201c-1%202-2%202-3%201-2-2-3-1-2%201%200%203-3%205-4%203s-2%201-1%204v3l2-2%202-1%202%201%201-4c0-2%202%200%204%203l2%202h2c2%201%204-4%203-5l-1%201-2%201c-2%200-2-1-2-4%200-6-1-7-3-4M27%20110l-2%202-1%20142v143l2%202%202%203h172a1441%201441%200%2000175-4l-156-1-157-1-1-69c0-66%200-68%202-69l157-1h156v-8l-157-1H62l-1-65%201-66%20158-1h156l-1-2-2-4c-4-3-343-3-346%200m218%20329c-5%203-6%207-3%2011%204%206%2013%202%2013-4%200-5-6-9-10-7m36%201c-1%201-2%202-1%203%201%203-1%205-2%203-1-1-1%200-1%201%200%203%201%204%205%205%203%201%209-2%209-3%200-2-5-4-6-3v-3c0-4-2-6-4-3m-129%200l-1%206c0%205%201%207%206%207s10-7%204-8c-3%200-4-1-3-3%200-3%200-3-2-3l-4%201m18%200c-2%204-3%206-2%208%202%202%203%201%203-1l1-4%201%202-1%204-1%202h-1c0%201%203%202%204%201l1%201h2c1%200%202-3%200-3l-1-3%201-3%201%201%202%201c2%201%203-2%200-5-1-2-8-3-10-1m21%200l-1%202-2%202c-3%201-3%205%200%208%203%202%208%202%2010-1%202-2%202-2%200-4l-2-3v-3c0-2-4-3-5-1m15%201c-3%202-2%208%200%2010s9%203%209%201l1-2c2-1%202-7%200-9-3-3-8-3-10%200m18%201c-2%203-2%204-1%207%203%207%2014%205%2014-3%200-6-9-9-13-4m-88-1l-2%201c-2-1-3%203-3%206%202%209%2015%206%2015-2%200-4-8-8-10-5m130%201l-3%201c-6%200-6%204-1%208l2%201c0-1%200-2%201-1v1l1%201%202-1%202-1c2%201%204-4%203-6l-3-2-3-1h-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e1c0c999acfe2fba8e377387739cad07/ca0a1/techletter.app-screenshot-1565626955164.webp 223w", "/static/e1c0c999acfe2fba8e377387739cad07/75680/techletter.app-screenshot-1565626955164.webp 445w", "/static/e1c0c999acfe2fba8e377387739cad07/0ba47/techletter.app-screenshot-1565626955164.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e1c0c999acfe2fba8e377387739cad07/e92b6/techletter.app-screenshot-1565626955164.png 223w", "/static/e1c0c999acfe2fba8e377387739cad07/e66bf/techletter.app-screenshot-1565626955164.png 445w", "/static/e1c0c999acfe2fba8e377387739cad07/6af66/techletter.app-screenshot-1565626955164.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e1c0c999acfe2fba8e377387739cad07/6af66/techletter.app-screenshot-1565626955164.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Yep 🔥`}</p>
    <p>{`Ok so global state management, how do you do it? You grab `}<a parentName="p" {...{
        "href": "https://github.com/reduxjs/redux"
      }}>{`Redux`}</a>{` or `}<a parentName="p" {...{
        "href": "https://github.com/mobxjs/mobx"
      }}>{`MobX`}</a>{`, or maybe `}<a parentName="p" {...{
        "href": "https://github.com/jamiebuilds/unstated"
      }}>{`Unstated`}</a>{` or `}<a parentName="p" {...{
        "href": "https://github.com/diegohaz/constate"
      }}>{`Constate`}</a>{` and you're done. Right?`}</p>
    <p>{`All those libraries give you a global store to put your data, allow every component to access that state, and manage re-renders. You get some way of updating that state and life is good.`}</p>
    <p>{`Sometimes there's extra features.`}</p>
    <p>{`But what if you don't want to learn yet another library? You just wanna share some state between a bunch of components. What then?`}</p>
    <h2 {...{
      "id": "global-state-without-the-hassle"
    }}>{`Global state without the hassle`}</h2>
    <p>{`The simplest approach is to put global state in your top-level component. Pass it down through props and if you want to change it, pass down some callbacks too.`}</p>
    <p>{`Works great and gets out of hand real fast. Passing props is cumbersome and you can create a situation where every little update re-renders your entire app.`}</p>
    <p>{`Here's a better solution 👉 You can share the `}<inlineCode parentName="p">{`state`}</inlineCode>{` and `}<inlineCode parentName="p">{`dispatch`}</inlineCode>{` from `}<inlineCode parentName="p">{`useReducer`}</inlineCode>{` through context and access them with a hook.`}</p>
    <p><img parentName="p" {...{
        "src": "/e543b034393ca69ba6c26af1c98dd51d/ChfELcI.gif",
        "alt": "mind blown"
      }}></img></p>
    <p>{`I'll explain using `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth"
      }}>{`useAuth`}</a>{` as an example, but the same approach works for anything.`}</p>
    <p>{`There's 3 parts to this story:`}</p>
    <ol>
      <li parentName="ol">{`A context provider component`}</li>
      <li parentName="ol">{`A reducer for state`}</li>
      <li parentName="ol">{`A hook providing our API`}</li>
    </ol>
    <p>{`Users render the context provider somewhere close to the root of their app. Similar to a theme provider, Apollo provider, etc.`}</p>
    <p>{`The provider feeds state from our reducer into the context. When you fire actions on the reducer, state in the context changes, and every component using the `}<inlineCode parentName="p">{`useAuth`}</inlineCode>{` hook re-renders with new data.`}</p>
    <p>{`It's pretty great.`}</p>
    <h2 {...{
      "id": "authprovider"
    }}>{`AuthProvider`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth/blob/master/src/AuthProvider.js"
      }}>{`file link`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2FAuthProvider.js%0A%0Aconst%20AuthContext%20%3D%20React.createContext(null)%0A%0Aexport%20const%20AuthProvider%20%3D%20(%7B%20children%20%7D)%20%3D%3E%20%7B%0A%20%20const%20auth0%20%3D%20new%20Auth0.WebAuth(%7B%0A%20%20%20%20%2F%2F%20initialization%20stuff%0A%20%20%7D)%0A%0A%20%20const%20%5Bstate%2C%20dispatch%5D%20%3D%20useReducer(authReducer%2C%20%7B%0A%20%20%20%20%2F%2F%20initial%20state%0A%20%20%7D)%0A%0A%20%20return%20(%0A%20%20%20%20%3CAuthContext.Provider%20value%3D%7B%5Bstate%2C%20dispatch%2C%20auth0%5D%7D%3E%0A%20%20%20%20%20%20%7Bchildren%7D%0A%20%20%20%20%3C%2FAuthContext.Provider%3E%0A%20%20)%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "574px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "89.23766816143497%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'356\\'%20viewBox=\\'0%200%20400%20356\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2035c-3%202-3%20285%200%20287%202%202%20350%202%20352%200%203-2%203-285%200-287-2-3-350-3-352%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c3466f16102d988b062e7c159e2bf60e/ca0a1/techletter.app-screenshot-1565626956122.webp 223w", "/static/c3466f16102d988b062e7c159e2bf60e/75680/techletter.app-screenshot-1565626956122.webp 445w", "/static/c3466f16102d988b062e7c159e2bf60e/4e18f/techletter.app-screenshot-1565626956122.webp 574w"],
                "sizes": "(max-width: 574px) 100vw, 574px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c3466f16102d988b062e7c159e2bf60e/e92b6/techletter.app-screenshot-1565626956122.png 223w", "/static/c3466f16102d988b062e7c159e2bf60e/e66bf/techletter.app-screenshot-1565626956122.png 445w", "/static/c3466f16102d988b062e7c159e2bf60e/86389/techletter.app-screenshot-1565626956122.png 574w"],
                "sizes": "(max-width: 574px) 100vw, 574px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c3466f16102d988b062e7c159e2bf60e/86389/techletter.app-screenshot-1565626956122.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`That's our context provider.`}</p>
    <p>{`The provider initializes `}<inlineCode parentName="p">{`auth0`}</inlineCode>{` using Auth0's API and configures some properties. Full version supports a bunch of config via props, overwriting defaults, etc.`}</p>
    <p>{`We call `}<inlineCode parentName="p">{`useReducer`}</inlineCode>{` to get a state object and the action dispatch function. Initialize state from local storage if you want persistence, or keep it empty to start with.`}</p>
    <p>{`I recommend defining initial values so your code doesn't have to deal with undefineds.`}</p>
    <p>{`Our provider renders `}<inlineCode parentName="p">{`AuthContext.Provider`}</inlineCode>{` and as its value uses the `}<inlineCode parentName="p">{`state`}</inlineCode>{` object, `}<inlineCode parentName="p">{`dispatch`}</inlineCode>{` function, and `}<inlineCode parentName="p">{`auth0`}</inlineCode>{` object.`}</p>
    <p>{`This was the trick to getting different `}<inlineCode parentName="p">{`useAuth`}</inlineCode>{` hooks to talk to each other. Using reducer state and dispatch as the context value.`}</p>
    <h3 {...{
      "id": "using-authprovider"
    }}>{`Using AuthProvider`}</h3>
    <p>{`In Gatsby you use the auth provider in `}<inlineCode parentName="p">{`gatsby-ssr`}</inlineCode>{` and `}<inlineCode parentName="p">{`gatsby-browser`}</inlineCode>{` to wrap your entire component tree. With create-react-app this goes around your App component, with other frameworks who knows.`}</p>
    <p>{`The higher up it renders, the more parts of your app share state.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20frontend%2Fgatsby-ssr%0A%2F%2F%20frontend%2Fgatsby-browser%0A%0Aexport%20const%20wrapRootElement%20%3D%20(%7B%20element%20%7D)%20%3D%3E%20(%0A%20%20%3CAuthProvider%3E%7Belement%7D%3C%2FAuthProvider%3E%0A)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "494px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'224\\'%20viewBox=\\'0%200%20400%20224\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2040c-2%202-1%20143%201%20145s342%202%20344%200%203-143%201-145-344-2-346%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/98def6c3269f5d9b3e1b091955458351/ca0a1/techletter.app-screenshot-1565626955924.webp 223w", "/static/98def6c3269f5d9b3e1b091955458351/75680/techletter.app-screenshot-1565626955924.webp 445w", "/static/98def6c3269f5d9b3e1b091955458351/32f69/techletter.app-screenshot-1565626955924.webp 494w"],
                "sizes": "(max-width: 494px) 100vw, 494px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/98def6c3269f5d9b3e1b091955458351/e92b6/techletter.app-screenshot-1565626955924.png 223w", "/static/98def6c3269f5d9b3e1b091955458351/e66bf/techletter.app-screenshot-1565626955924.png 445w", "/static/98def6c3269f5d9b3e1b091955458351/d72d4/techletter.app-screenshot-1565626955924.png 494w"],
                "sizes": "(max-width: 494px) 100vw, 494px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/98def6c3269f5d9b3e1b091955458351/d72d4/techletter.app-screenshot-1565626955924.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "auth-reducer"
    }}>{`Auth reducer`}</h2>
    <p>{`The auth reducer takes care of state transitions. `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth/blob/master/src/authReducer.js"
      }}>{`full file`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20frontend%2Fsrc%2Fauth.js%0A%0Afunction%20authReducer(state%2C%20action)%20%7B%0A%20%20switch%20(action.type)%20%7B%0A%20%20%20%20case%20%22login%22%3A%0A%20%20%20%20%20%20const%20%7B%20authResult%2C%20user%20%7D%20%3D%20action%0A%20%20%20%20%20%20const%20expiresAt%20%3D%20authResult.expiresIn%20*%201000%20%2B%20new%20Date().getTime()%0A%0A%20%20%20%20%20%20localStorage.setItem(%22expires_at%22%2C%20JSON.stringify(expiresAt))%0A%20%20%20%20%20%20localStorage.setItem(%22user%22%2C%20JSON.stringify(user))%0A%0A%20%20%20%20%20%20return%20%7B%20user%2C%20expiresAt%20%7D%0A%20%20%20%20case%20%22logout%22%3A%0A%20%20%20%20%20%20localStorage.removeItem(%22expires_at%22)%0A%20%20%20%20%20%20localStorage.removeItem(%22user%22)%0A%0A%20%20%20%20%20%20return%20%7B%20user%3A%20%7B%7D%2C%20expiresAt%3A%20null%20%7D%0A%20%20%20%20default%3A%0A%20%20%20%20%20%20return%20state%0A%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "694px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "78.9237668161435%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'315\\'%20viewBox=\\'0%200%20400%20315\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2030a7035%207035%200%20001%20257c2%202%20358%202%20360%200%202-1%202-11%202-129l-1-128c-1-3-361-3-362%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/efeb0d0245b66da8a38ae783ca44a9a7/ca0a1/techletter.app-screenshot-1565626956251.webp 223w", "/static/efeb0d0245b66da8a38ae783ca44a9a7/75680/techletter.app-screenshot-1565626956251.webp 445w", "/static/efeb0d0245b66da8a38ae783ca44a9a7/181fb/techletter.app-screenshot-1565626956251.webp 694w"],
                "sizes": "(max-width: 694px) 100vw, 694px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/efeb0d0245b66da8a38ae783ca44a9a7/e92b6/techletter.app-screenshot-1565626956251.png 223w", "/static/efeb0d0245b66da8a38ae783ca44a9a7/e66bf/techletter.app-screenshot-1565626956251.png 445w", "/static/efeb0d0245b66da8a38ae783ca44a9a7/31198/techletter.app-screenshot-1565626956251.png 694w"],
                "sizes": "(max-width: 694px) 100vw, 694px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/efeb0d0245b66da8a38ae783ca44a9a7/31198/techletter.app-screenshot-1565626956251.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`If you're not familiar with reducers: it's a function that takes the current state and an action, and calculates the next state. Always returning a fresh object.`}</p>
    <p>{`In our case the `}<inlineCode parentName="p">{`login`}</inlineCode>{` and `}<inlineCode parentName="p">{`logout`}</inlineCode>{` actions handle the user model and cookie expiration time. Both actions also save data to local storage so it persists across page reloads.`}</p>
    <h2 {...{
      "id": "useauth-hook-itself"
    }}>{`useAuth hook itself`}</h2>
    <p>{`With heavy lifting moved to the context provider and auth reducer, our `}<inlineCode parentName="p">{`useAuth`}</inlineCode>{` hook becomes a sort of thin wrapper and API provider. `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth/blob/master/src/useAuth.js"
      }}>{`full file`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2FuseAuth.js%0A%0Aexport%20const%20useAuth%20%3D%20()%20%3D%3E%20%7B%0A%20%20%20%20%2F%2F%20this%20is%20the%20state%20stuff%0A%20%20%20%20const%20%7B%20state%2C%20dispatch%2C%20auth0%20%7D%20%3D%20useContext(%0A%20%20%20%20%20%20%20%20AuthContext%0A%20%20%20%20)%3B%0A%0A%20%20%20%20const%20login%20%3D%20()%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20auth0.authorize()%3B%0A%20%20%20%20%7D%3B%0A%0A%20%20%20%20const%20logout%20%3D%20()%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20auth0.logout(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20returnTo%3A%20callback_domain%0A%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%20%20%20%20dispatch(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20type%3A%20%22logout%22%0A%20%20%20%20%20%20%20%20%7D)%3B%0A%0A%20%20%20%20%20%20%20%20%2F%2F%20Return%20to%20the%20homepage%20after%20logout.%0A%20%20%20%20%20%20%20%20navigate(%22%2F%22)%3B%0A%20%20%20%20%7D%3B%0A%0A%20%20%20%2F%2F%20...%0A%0A%20%20%20%20const%20isAuthenticated%20%3D%20()%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20return%20state.expiresAt%20%26%26%20new%20Date().getTime()%20%3C%20state.expiresAt%3B%0A%20%20%20%20%7D%3B%0A%0A%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20isAuthenticated%2C%0A%20%20%20%20%20%20%20%20user%3A%20state.user%2C%0A%20%20%20%20%20%20%20%20userId%3A%20state.user%20%3F%20state.user.sub%20%3A%20null%2C%0A%20%20%20%20%20%20%20%20login%2C%0A%20%20%20%20%20%20%20%20logout%2C%0A%20%20%20%20%20%20%20%20handleAuthentication%0A%20%20%20%20%7D%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "686px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "126.90582959641254%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'508\\'%20viewBox=\\'0%200%20400%20508\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%2029a19284%2019284%200%20001%20451h359l1-226V29l-181-1-180%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a32481e7851d0156d7236d3f60271d9f/ca0a1/techletter.app-screenshot-1565626956395.webp 223w", "/static/a32481e7851d0156d7236d3f60271d9f/75680/techletter.app-screenshot-1565626956395.webp 445w", "/static/a32481e7851d0156d7236d3f60271d9f/7dbce/techletter.app-screenshot-1565626956395.webp 686w"],
                "sizes": "(max-width: 686px) 100vw, 686px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a32481e7851d0156d7236d3f60271d9f/e92b6/techletter.app-screenshot-1565626956395.png 223w", "/static/a32481e7851d0156d7236d3f60271d9f/e66bf/techletter.app-screenshot-1565626956395.png 445w", "/static/a32481e7851d0156d7236d3f60271d9f/f6386/techletter.app-screenshot-1565626956395.png 686w"],
                "sizes": "(max-width: 686px) 100vw, 686px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a32481e7851d0156d7236d3f60271d9f/f6386/techletter.app-screenshot-1565626956395.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The state management part of `}<inlineCode parentName="p">{`useAuth`}</inlineCode>{` is that `}<inlineCode parentName="p">{`useContext`}</inlineCode>{` call. It hooks into the context shared by `}<inlineCode parentName="p">{`AuthProvider`}</inlineCode>{` and gets access to the `}<inlineCode parentName="p">{`state`}</inlineCode>{` object and `}<inlineCode parentName="p">{`dispatch`}</inlineCode>{` method.`}</p>
    <p>{`That gives any component that uses `}<inlineCode parentName="p">{`useAuth`}</inlineCode>{` access to the same shared state.`}</p>
    <p>{`You could use `}<inlineCode parentName="p">{`useContext`}</inlineCode>{` directly. I prefer using a custom hook because it makes your code easier to read.`}</p>
    <p>{`What's better, doing this everywhere you want to access some shared state:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20SomeContext%20from%20'...'%0A%0Aconst%20MyThing%20%3D%20()%20%3D%3E%20%7B%0A%09const%20%5Bstate%2C%20dispatch%5D%20%3D%20useContext(SomeContext)%0A%0A%09%2F%2F%20...%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "526px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'224\\'%20viewBox=\\'0%200%20400%20224\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%2038c-2%201-2%208-2%2075v73l2%201c4%203%20344%203%20348%200l2-1v-73c0-70%200-74-2-75-3-3-346-3-348%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d6830c47822f3bda7e83420ef20e6068/ca0a1/techletter.app-screenshot-1565626956742.webp 223w", "/static/d6830c47822f3bda7e83420ef20e6068/75680/techletter.app-screenshot-1565626956742.webp 445w", "/static/d6830c47822f3bda7e83420ef20e6068/9752a/techletter.app-screenshot-1565626956742.webp 526w"],
                "sizes": "(max-width: 526px) 100vw, 526px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d6830c47822f3bda7e83420ef20e6068/e92b6/techletter.app-screenshot-1565626956742.png 223w", "/static/d6830c47822f3bda7e83420ef20e6068/e66bf/techletter.app-screenshot-1565626956742.png 445w", "/static/d6830c47822f3bda7e83420ef20e6068/2d7ab/techletter.app-screenshot-1565626956742.png 526w"],
                "sizes": "(max-width: 526px) 100vw, 526px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d6830c47822f3bda7e83420ef20e6068/2d7ab/techletter.app-screenshot-1565626956742.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Or this`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20useMyContext%0A%0Aconst%20MyThing%20%3D%20()%20%3D%3E%20%7B%0A%09const%20%7B%20doTheThing%20%7D%20%3D%20useMyContext()%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "430px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.0896860986547%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'241\\'%20viewBox=\\'0%200%20400%20241\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2046c-2%202-1%20148%201%20150s334%202%20336%200%203-148%201-150-336-2-338%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1f4482d0d7fb97a72e769aee23c6c72f/ca0a1/techletter.app-screenshot-1565626956228.webp 223w", "/static/1f4482d0d7fb97a72e769aee23c6c72f/866c5/techletter.app-screenshot-1565626956228.webp 430w"],
                "sizes": "(max-width: 430px) 100vw, 430px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1f4482d0d7fb97a72e769aee23c6c72f/e92b6/techletter.app-screenshot-1565626956228.png 223w", "/static/1f4482d0d7fb97a72e769aee23c6c72f/05ed2/techletter.app-screenshot-1565626956228.png 430w"],
                "sizes": "(max-width: 430px) 100vw, 430px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/1f4482d0d7fb97a72e769aee23c6c72f/05ed2/techletter.app-screenshot-1565626956228.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`I know what I prefer :)`}</p>
    <p>{`With a custom hook you can use `}<inlineCode parentName="p">{`dispatch`}</inlineCode>{` with carefully controlled values internally. Nobody needs to know what's going on. All they need to remember is your convenient API.`}</p>
    <h2 {...{
      "id": "️"
    }}>{`✌️`}</h2>
    <p>{`So that's how you can use React hooks to build powerful abstractions on top of global state shared by all.`}</p>
    <p>{`What do you think?`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      